import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TimeLogService {
    private http = inject(HttpClient);
    private apiUrl = '/api/reporting/timelogs';

    // Get my time logs (paged)
    getMyLogs(page: number = 1, pageSize: number = 20): Observable<any> {
        const params = new HttpParams()
            .set('page', page)
            .set('pageSize', pageSize);

        return this.http.get<any>(`${this.apiUrl}/my`, { params });
    }

    // Get my time logs (paged, date range)
    getMyLogsByDateRange(startDate: Date, endDate: Date, page: number = 1, pageSize: number = 20): Observable<any> {
        const params = new HttpParams()
            .set('page', page)
            .set('pageSize', pageSize)
            .set('startDate', startDate.toISOString())
            .set('endDate', endDate.toISOString());

        return this.http.get<any>(`${this.apiUrl}/my`, { params });
    }

    // Get all time logs (Admin/SystemAdmin, paged)
    getAllLogs(page: number = 1, pageSize: number = 20, startDate?: Date, endDate?: Date): Observable<any> {
        let params = new HttpParams()
            .set('page', page)
            .set('pageSize', pageSize);

        if (startDate) {
            params = params.set('startDate', startDate.toISOString());
        }

        if (endDate) {
            params = params.set('endDate', endDate.toISOString());
        }

        return this.http.get<any>(this.apiUrl, { params });
    }

    // Create time log
    create(timeLog: any): Observable<any> {
        return this.http.post(this.apiUrl, timeLog);
    }

    // Get time log by ID
    getById(id: string): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/${id}`);
    }

    // Update time log
    update(id: string, timeLog: any): Observable<any> {
        return this.http.put(`${this.apiUrl}/${id}`, timeLog);
    }

    // Delete time log
    delete(id: string): Observable<any> {
        return this.http.delete(`${this.apiUrl}/${id}`);
    }
}
